import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Radio as Component } from './radio';
import type { TRadio, IDeps } from './models';
import styles from './styles/radio.css';

export const Radio = createWidget<IDeps, TRadio>({
    styles,
})(Component);
